import React from "react";
import "./PageStyles.css";
import "./ServicesPage.css";

const ALL_SERVICES = [
  {
    cat: "Repair Services",
    items: [
      "Window Repair",
      "Screen Repair",
      "Glass Repair",
      "Storm Window Service",
      "Frame & Hardware Repair",
    ],
  },
  {
    cat: "In-Store Services",
    items: [
      "Key Cutting",
      "Paint Matching",
      "Pipe Cutting",
      "Lumber Cutting",
      "Project Advice",
    ],
  },
  {
    cat: "Tools & Supplies",
    items: [
      "Power Tools",
      "Hand Tools",
      "Fasteners & Hardware",
      "Plumbing Supplies",
      "Electrical Supplies",
      "Paint & Finishes",
      "Lawn & Garden",
      "Storage Solutions",
    ],
  },
];

function ServicesPage() {
  return (
    <div className="page">
      <div className="page-hero page-hero--dark">
        <div className="container">
          <div className="page-hero__eyebrow">City Hardware — Detroit</div>
          <h1 className="page-hero__heading">
            Tools, Supplies
            <br />
            &amp; Services
          </h1>
          <p className="page-hero__sub">
            One stop for everyday hardware needs. Tools, supplies, repairs, and
            expert help — in Detroit.
          </p>
          <div className="page-hero__actions">
            <a href="tel:+13135550100" className="btn btn--red">
              Call Us
            </a>
            <a href="/contact" className="btn btn--outline-white">
              Get a Quote
            </a>
          </div>
        </div>
      </div>

      <section className="page-section">
        <div className="container">
          {ALL_SERVICES.map(({ cat, items }) => (
            <div key={cat} className="services-category">
              <h2 className="services-category__heading">{cat}</h2>
              <div className="services-category__grid">
                {items.map((item) => (
                  <div key={item} className="services-category__card">
                    <span>{item}</span>
                    <a href="/contact" className="services-category__link">
                      Inquire →
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="page-cta-band">
        <div className="container page-cta-band__inner">
          <div>
            <h2 className="page-cta-band__heading">Don't See What You Need?</h2>
            <p className="page-cta-band__sub">
              Give us a call — we likely carry it or can order it for you.
            </p>
          </div>
          <div className="page-cta-band__actions">
            <a href="tel:+13135828860" className="btn btn--red">
              (313) 582-8860
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ServicesPage;
